import { WORKFLOW } from "src/appConfig";
import classes from "./styles.module.scss";
import { CoockiesWrapper } from "./CoockiesWrapper";
import { useAutoScrollToTop } from "@hooks/useAutoScrollToTop";

export const Cookies = () => {
  const isWalky = WORKFLOW === "WALKY";

  useAutoScrollToTop('auto');

  return (
    <CoockiesWrapper
      title="Cookie Policy"
      lastUpdated={new Date("2024-09-23").toLocaleDateString()}
    >
      <div className={classes.item}>
        <p>
          Our Privacy Policy describes how we collect and use information, and
          what choices you have. One way we collect information is through the
          use of a technology called “cookies,” pixels or web beacons, local
          storage, mobile device IDs, and software development kits (SDKs).
          These and similar technologies help us and our partners collect data,
          including usage data, identifiers, and device information.
        </p>
        <h3 className={classes.titleBlock}>What’s a cookie?</h3>
        <p>
          We and our partners use a variety of ways to automatically collect
          data when you visit our sites and use our apps. This Cookie Policy
          refers to these technologies collectively as “cookies.”
          <br />
          <br /> When you go online, you use a program called a “browser” (like
          Firefox, Safari, or Chrome). Most websites store a small amount of
          text in the browser called a “cookie.” A cookie can later be read when
          your browser connects to a web server in the same domain that placed
          the cookie. The text in a cookie contains a string of numbers and
          letters that may uniquely identify your device and can contain other
          information as well. This allows the web server to recognize your
          browser over time, each time it connects to that web server. <br />
          <br /> We use session cookies (that last until you close your browser)
          or persistent cookies (that last until you or your browser delete
          them). For example, we use persistent cookies to store your language
          preferences or other settings so you don’t have to set them up every
          time you visit {isWalky ? "Walky" : "Easyfit"}. <br />
          <br /> Web beacons are electronic images (also called single-pixel or
          clear GIFs) that are contained within a website or email. When your
          browser opens a webpage or email that contains a web beacon, it
          automatically connects to the web server that hosts the image
          (typically operated by a third party). This allows that web server to
          log information about your device and to set and read its own cookies.
          In the same way, third-party content on our websites (such as embedded
          videos and plug-ins) results in your browser connecting to the
          third-party web server that hosts that content. We also include web
          beacons in our email messages to tell us if you open and interact with
          them.
          <br />
          <br /> Mobile analytics and advertising IDs are generated by operating
          systems for mobile devices (iOS and Android) and can be accessed and
          used by apps in much the same way that websites access and use
          cookies. Our apps contain software that enables us and our third-party
          analytics and advertising partners to access these mobile IDs.
          <br />
          <br /> Some of the cookies we use are associated with your {isWalky ? "Walky" : "Easyfit"}
          account (including information about you, such as the email address
          you gave us) and other cookies are not.
        </p>
        <h3 className={classes.titleBlock}>
          How we and our partners use cookies
        </h3>
        <p>
          We, and our analytics and advertising partners, use these technologies
          in our websites, apps, and online services to collect personal data
          (such as the pages you visit, the links you click on, and similar
          usage information, identifiers, and device information) when you use
          our services, including personal data about your online activities
          over time and across different websites or online services. There are
          four categories for which we and third parties may use cookies.
        </p>
        <p>
          <b>Essential cookies.</b> We may use essential cookies to enable you
          to sign-in, help protect you and your data, and remember your settings
          and preferences, like the language you prefer and your privacy
          settings.
        </p>
        <p>
          <b>Analytics cookies.</b> We use analytics cookies to make {isWalky ? "Walky" : "Easyfit"}
          better. For example, these cookies help us analyze how our websites
          and apps perform and tell us how many people use a certain feature and
          how popular it is.
        </p>
        <p>
          <b>Personalization cookies.</b> We may use cookies to help us remember
          your preferences, including which websites you’ve interacted with so
          we can show you related content you might like.
        </p>
        <p>
          <b>Marketing cookies.</b> We and our advertising and social media
          partners may use cookie data to track your interaction with the site
          or app, develop inferences, and deliver and tailor interest-based
          advertising, including marketing {isWalky ? "Walky" : "Easyfit"} on other websites and apps.
        </p>
        <p>
          We and/or our partners also share the data we collect or infer with
          third parties for these purposes. For more information about the
          third-party analytics and advertising partners that collect personal
          information on our services, please see the section “What we do with
          the info we collect.” in our Privacy Policy.
        </p>
        <h3 className={classes.titleBlock}>Changes to this policy</h3>
        <p>
          We may change this policy from time to time and if we do, we’ll post
          any changes on this page. If you continue to use {isWalky ? "Walky" : "Easyfit"} after those
          changes are in effect, you agree to the new policy.
        </p>
        <h3 className={classes.titleBlock}>Contact us</h3>
        <p>
          The best way to get in touch with us is by
          emailing {isWalky ? "support@walky.fit" : "support@easyfit.me"}  or at
          <br />
          <br /> Straiton Limited, Ltd.
          <br />
          Attention: Privacy Officer
          <br />
          Nirvana - Aipeias, Alpha Tower Pavlou, Office 11, 1st floor
          <br />
          Limassol, Cyprus
        </p>
      </div>
    </CoockiesWrapper>
  );
};
